import React from 'react';
import T from 'prop-types';
import FormatUtils from '../../../utils/FormatUtils';

const NUMBER_OF_VERTICAL_LINES = 25;
const NUMBER_OF_VERTICAL_SPACES = NUMBER_OF_VERTICAL_LINES - 1;
const LINE_WIDTH = 2;
const WIDTH_OF_TWO_LINES = 2 * LINE_WIDTH;

const Ruler = ({ episodeDuration = 0, width }) => {
  const getTimePositionForLine = (ordinal) => {
    const distanceInSeconds = episodeDuration / NUMBER_OF_VERTICAL_SPACES;
    return Math.floor(distanceInSeconds * ordinal);
  };

  const getPixelPositionForLine = (ordinal) => {
    const roomForLines = width - WIDTH_OF_TWO_LINES;
    const distanceInPixels = roomForLines / NUMBER_OF_VERTICAL_SPACES;
    return Math.floor(distanceInPixels * ordinal);
  };

  const getTimeAndPixelPositionForLine = (ordinal) => ({
    time: getTimePositionForLine(ordinal),
    pixel: getPixelPositionForLine(ordinal),
  });

  const renderVerticalLines = () => {
    const linePositions = [];
    for (let i = 0; i < NUMBER_OF_VERTICAL_LINES; i++) {
      linePositions.push(getTimeAndPixelPositionForLine(i));
    }
    return (
      <div>
        {linePositions
          .filter(({ pixel }) => pixel > -1)
          .map(({ time, pixel }) => {
            return (
              <div
                key={pixel + time}
                className="editor-timeline__ruler__line--vertical"
                style={{ left: `${pixel}px` }}
              >
                <span className="editor-timeline__ruler__line--vertical__timestamp">
                  {FormatUtils.formatTimeWholeSeconds(time)}
                </span>
              </div>
            );
          })}
      </div>
    );
  };

  const renderHorizontalLine = () => {
    return <div className="editor-timeline__ruler__line--horizontal" />;
  };

  return (
    <div className="editor-timeline__ruler">
      {renderVerticalLines()}
      {renderHorizontalLine()}
    </div>
  );
};

Ruler.propTypes = {
  width: T.number.isRequired,
  episodeDuration: T.number,
};

export default Ruler;
